// Ensure HTTPS protocol to avoid mixed content errors
const ensureHttps = (url) => {
  if (!url) return url;
  return url.replace(/^http:\/\//i, 'https://');
};

export const baseUrl = ensureHttps(process.env.VUE_APP_BASE_URL);
export const apiBaseUrl = ensureHttps(process.env.VUE_APP_API_URL);